import { env } from '@/config/env';

import { createPublicCatalogService } from '../api/catalogService';

export function createCatalogComposition(config = env) {
  return {
    service: createPublicCatalogService(config),
    media: {
      ...(config.catalogDataSource === 'mock'
        ? { baseUrl: '/' }
        : config.catalogMediaBaseUrl
          ? { baseUrl: config.catalogMediaBaseUrl }
          : {}),
      placeholderUrl: '/assets/catalog/catalog-placeholder.svg',
    },
  };
}
